import { MyImage } from '~/components/ui/MyImage'
import { useAtom, useAtomValue } from 'jotai'
import { IMessage, placeholderAtom } from '../atom'
import Message from './Message'
import {
  useListenUserTouchInMessage,
  useScrollMessageListToBottom,
} from '../hooks'
import { useEffect } from 'react'
import classNames from 'classnames'

interface Props {
  messages: IMessage[]
  isTyping: boolean
  isTypingRef: React.MutableRefObject<boolean>
  className?: string
}

export function MessageList({
  messages,
  isTyping,
  isTypingRef,
  className,
}: Props) {
  const scrollMessageListToBottom = useScrollMessageListToBottom()
  const { isUserTouchRef } = useListenUserTouchInMessage(isTyping, isTypingRef)
  const placeholder = useAtomValue(placeholderAtom)

  useEffect(() => {
    // console.log('useEffect-scrollMessageListToBottom', isUserTouchRef.current)
    if (!isUserTouchRef.current) {
      scrollMessageListToBottom()
    }
  }, [
    messages[messages.length - 1]?.content,
    messages[messages.length - 1].reasoning,
  ])

  return (
    <div className={classNames(className)}>
      <div className=" relative ">
        {messages.map((it, index) => {
          return <Message msg={it} key={it.id} />
        })}

        {/* 消息已经发出，但是还没有收到任何文字时，显示状态了 */}

        {isTyping && !!placeholder && (
          <div className="flex items-center gap-2">
            {placeholder?.thinkingEnabled && (
              <div className="flex items-center gap-1 p-2 rounded-lg bg-neutral-200">
                <MyImage
                  src={'/images/deepseek/assistant.svg'}
                  className="w-[14px] h-[14px] block"
                />
                <div>深度思考中</div>
                <MyImage
                  src={'/images/deepseek/loading.png'}
                  className="w-[14px] h-[14px] leading-none block animate-spin origin-center"
                />
              </div>
            )}
            {!placeholder?.thinkingEnabled && (
              <div className="flex items-center gap-1 p-2 rounded-lg bg-neutral-200">
                <div>处理中</div>
                <MyImage
                  src={'/images/deepseek/loading.png'}
                  className="w-[14px] h-[14px] leading-none block animate-spin origin-center"
                />
              </div>
            )}
          </div>
        )}

        <div className="h-[46px]"></div>
      </div>
    </div>
  )
}
